module.exports = __webpack_public_path__ + "static/media/tlyfe@3x.e69a18c7.png";